export const propsTipoChamado = {
    pUrl: "/api/TipoChamado",
    pCabecalho: "descricao|Descrição,id|Código,id_Principal|Pai,ativo|Ativo",
    pTitulo: "Cadastro de tipo chamado",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'number',
            visible: false
        },
        {
            label: 'Descrição',
            campo: 'descricao',
            type: 'text',
            visible: true
        },
        {
            label: 'Código do Pai',
            campo: 'id_Principal',
            type: 'option',
            visible: true,
            typePri: true,
            lista: {
                url: '/api/TipoChamado/listarPai',
                value: 'id',
                text: 'descricao'
            }
        },
        {
            label: "Cor",
            campo: "cor",
            type: "text",
            visible: true
        },
        {
            label: "Letra do Chamado",
            campo: "codigo",
            type: "text",
            visible: true
        },
        {
            label: "Cor da fonte",
            campo: "fonte",
            type: "text",
            visible: true
        },
        {
            label: "Cor da borda",
            campo: "borda",
            type: "text",
            visible: true
        },
        {
            label: "Cor do icone",
            campo: "corIcone",
            type: "text",
            visible: true
        },
        {
            label: "Ativo",
            campo: "ativo",
            type: "checkbox",
            visible: true,
            default: "true"
        },
        {
            label: "Urgencia",
            campo: "urgencia",
            type: "checkbox",
            visible: false,
            default: "false"
        },
        {
            label: "Som",
            campo: "som",
            type: "text",
            visible: false
        },
    ]
}; // Pronto

export const propsSetor = {
    pUrl: "/api/Setor",
    pCabecalho: "descricao|Descrição,id|Código,codigoSetor|Nome do Setor,ativo|Ativo",
    pTitulo: "Cadastro de setor",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Descrição',
            campo: 'descricao',
            type: 'text',
            visible: true
        },
        {
            label: 'Código do Setor',
            campo: 'codigoSetor',
            type: 'text',
            visible: true
        },
        {
            label: 'Ativo',
            campo: 'ativo',
            type: 'checkbox',
            visible: true,
            default: "true"
        },
    ]
}; // Pronto

export const propsQuarto = {
    pUrl: "/api/Quarto",
    pCabecalho: "descricao|Descrição,id|Código,codigoQuarto|Código do Quarto,setor|Nome do Setor,ativo|Ativo",
    pTitulo: "Cadastro de quarto",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Descrição',
            campo: 'descricao',
            type: 'text',
            visible: true
        },
        {
            label: 'Código do Quarto',
            campo: 'codigoQuarto',
            type: 'text',
            visible: true
        },
        {
            label: 'Setor',
            campo: 'setor',
            type: 'option',
            visible: true,
            lista: {
                url: '/api/setor/listar',
                value: 'id',
                text: 'descricao'
            }
        },
        {
            label: 'Ativo',
            campo: 'ativo',
            type: 'checkbox',
            visible: true,
            default: "true"
        },
    ]
}; // Pronto

export const propsLeito = {
    pUrl: "/api/Leito",
    pCabecalho: "descricao|Descrição,id|Código,link|Link de Acesso,codigoLeito|Codigo do Leito,quarto|Quarto",
    pTitulo: "Lista de Leito",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Descrição',
            campo: 'descricao',
            type: 'text',
            visible: true
        },
        {
            label: 'Codigo do Leito',
            campo: 'codigoLeito',
            type: 'text',
            visible: true
        },
        {
            label: 'Quarto',
            campo: 'quarto',
            type: 'option',
            visible: true,
            lista: {
                url: '/api/Quarto/listar',
                value: 'id',
                text: 'descricao'
            }
        },
    ]
}; // Pronto

export const propsLeitoLimpar = {
    pCabecalho: "descricao|Descrição,id|Código,link|Link de Acesso,codigoLeito|Codigo do Leito,quarto|Quarto,chamadosAbertos|Chamados Abertos",
    pTitulo: "Lista de leito com chamado em Aberto",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Descrição',
            campo: 'descricao',
            type: 'text',
            visible: true
        },
        {
            label: 'Codigo do Leito',
            campo: 'codigoLeito',
            type: 'text',
            visible: true
        },
        {
            label: 'Quarto',
            campo: 'quarto',
            type: 'option',
            visible: true,
            lista: {
                url: '/api/Quarto/listar',
                value: 'id',
                text: 'descricao'
            }
        },
        {
            label: 'Chamados Abertos',
            campo: 'chamadosAbertos',
            type: 'text',
            visible: true
        },
    ]
};

export const propsProfissional = {
    pUrl: "/api/profissional",
    pCabecalho: "nome|Nome,id|Código,sigla|Cadastro,numero|Numero,uf|UF,cbos|CBOS",
    pTitulo: "Cadastro de profissional",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Nome',
            campo: 'nome',
            type: 'text',
            visible: true
        },
        {
            label: 'Cadastro',
            campo: 'sigla',
            type: 'text',
            visible: true
        },
        {
            label: 'Numero',
            campo: 'numero',
            type: 'text',
            visible: true
        },
        {
            label: 'Data de Inclusão',
            campo: 'dtInclusao',
            type: 'date',
            visible: false
        },
        {
            label: 'Data de Alteração',
            campo: 'dtAlteracao',
            type: 'date',
            visible: false
        },
        {
            label: 'UF',
            campo: 'uf',
            type: 'text',
            visible: true
        },
        {
            label: 'CBOS',
            campo: 'cbos',
            type: 'text',
            visible: true
        },
        {
            label: 'Ativo',
            campo: 'ativo',
            type: 'checkbox',
            visible: true,
            default: "true"
        },
    ]
};

export const propsEquipamentos = {
    pUrl: "/api/equipamento",
    pCabecalho: "id|Código,ativo|Ativo,numSerie|Número de Série,leito|Leito,tipoChamado|Tipo Chamado",
    pTitulo: "Cadastro de equipamentos",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Data',
            campo: 'data',
            type: 'date',
            visible: false
        },
        {
            label: 'Hora',
            campo: 'hora',
            type: 'text',
            default: '00:00',
            visible: false
        },
        {
            label: 'Data',
            campo: 'dtAtualizacao',
            type: 'date',
            visible: false
        },
        {
            label: 'Hora',
            campo: 'hrAtualizacao',
            type: 'text',
            default: '00:00',
            visible: false
        },
        {
            label: 'Leito',
            campo: "leito",
            type: 'option',
            visible: true,
            lista: {
                url: '/api/leito/listar',
                value: 'id',
                text: "descricaoCompleta"
                // ,  subLista: "quarto"
            }
        },
        {
            label: 'Tipo Chamado',
            campo: 'tipoChamado',
            type: 'option',
            visible: true,
            lista: {
                url: '/api/TipoChamado/listar',
                value: 'id',
                text: 'descricao'
            }
        },
        {
            label: 'Numero de Série',
            campo: 'numSerie',
            type: 'text',
            visible: true
        },
        {
            label: 'Ativo',
            campo: 'ativo',
            type: 'checkbox',
            visible: true,
            default: "true"
        },
        {
            label: 'Possui Bateria',
            campo: 'possuiBateria',
            type: 'checkbox',
            visible: true,
            default: "true"
        },
        {
            label: 'Bateria',
            campo: 'bateria',
            type: 'number',
            visible: true
        },
        {
            label: 'Tempo Atualização',
            campo: 'tempoAtualizacao',
            type: 'number',
            visible: false
        },
        {
            label: 'Tempo Atualização Desc',
            campo: 'tempoAtualizacaoDesc',
            type: 'text',
            visible: false
        },

    ]
}; // Pronto

export const propsResponsavelSetor = {
    pUrl: "/api/Profissional",
    pCabecalho: "nome|Nome,id|Código,sigla|Cadastro,numero|Numero,uf|UF,cbos|CBOS",
    pTitulo: "Cadastro de Responsavel por Setor",
    pCampos: [
        {
            label: 'Código',
            campo: 'id',
            type: 'text',
            visible: false
        },
        {
            label: 'Nome',
            campo: 'nome',
            type: 'text',
            visible: true
        },
        {
            label: 'Setor Responsavel',
            campo: 'setor',
            type: 'option',
            visible: true,
            lista: {
                url: '/api/setor/listar',
                value: 'id',
                text: 'descricao'
            }
        },
        // {
        //     label: 'Escala de Plantão',
        //     campo: '',
        //     type: 'text',
        //     visible: true
        // },
        {
            label: 'Ativo',
            campo: 'ativo',
            type: 'checkbox',
            visible: true,
            default: "true"
        },
    ]
};